import Home from '../pages/HomePage/HomePage.vue'
import About from '../pages/AboutPage/AboutPage.vue'
import ServerStatus from '../pages/ServerStatusPage'
import ServerTimeout from '../pages/ServerTimeoutPage'
import LoginPageInvira from '../pages/LoginPage/index.vue'
import PasswordPageInvira from '../pages/PasswordPage/index.vue'

const routes = [
    { name: "root", path: "/", redirect: { name: "home" } },
    { name: "home", path: "/home", component: Home, meta: { requiresAuth: true } },
    { name: "about", path: "/about", component: About },
    { name: "serverStatus", path: "/server-status", component: ServerStatus },
    { name: "serverTimeout", path: "/server-timeout", component: ServerTimeout },
    // Login con redirección a cambio de contraseña cuando mustChangePassword (primer login)
    { name: "login", path: "/login", component: LoginPageInvira },
    // Página de cambio de contraseña (override Dracul): redirige a /home al terminar
    { name: "password", path: "/password", component: PasswordPageInvira, meta: { requiresAuth: true } },
]

export default routes
